import { useEntertainerEngagementContext } from '@contexts/EntertainerEngagementContext';
import { DynamicAction } from '@shared/types/app';

import { useSeriesByTagSlug } from '@queries/TagQueries';

import { useDynamicAction } from '@hooks/useDynamicAction';

import { createScreenComponent } from '@utilities/createScreenComponent';

import { Screen } from '@components/layout/Screen';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { ShowsTabContent } from '@screens/CommunityScreen/components/ShowsTabContent';

interface SeriesEventsScreenProps {
  tagSlug: string;
}

export const SeriesShowsScreen = createScreenComponent<
  SeriesEventsScreenProps,
  {
    filter?: string;
    isSuggestionModeDefault?: 'true';
    hideOpenStages?: 'true';
    showTitleOverrides?: 'true';
    hideEntertainerMenuButton?: 'true';
    addShowAction?: 'default' | 'mention';
    addShowText?: string;
  }
>(({ tagSlug, f7route }) => {
  const { isFetched: seriesIsReady, series, seriesHost } = useSeriesByTagSlug(tagSlug);

  const { openGatedAddShowPopup } = useEntertainerEngagementContext();
  const { handleDynamicAction } = useDynamicAction();

  const handleAddEvent = () => {
    if (f7route?.query?.addShowAction === 'mention') {
      handleDynamicAction({
        action: DynamicAction.SplashNotificationMentionEvent,
        payload: {
          cityId: series.city._id,
        },
      });
    } else {
      openGatedAddShowPopup({ cityId: series.city._id });
    }
  };

  const hideOpenStages = f7route?.query?.hideOpenStages === 'true';
  const showTitleOverrides = f7route?.query?.showTitleOverrides === 'true';
  const isSuggestionModeDefault = f7route?.query?.isSuggestionModeDefault === 'true';
  const hideEntertainerMenuButton = f7route?.query?.hideEntertainerMenuButton === 'true';
  const queryParams = new URLSearchParams(f7route?.query ?? {});
  const back = `/noauth/series/${tagSlug}/shows?${queryParams.toString()}`;

  return (
    <Screen
      name="Series Events Screen"
      hideToolbar
      disableLocationPermissionGate
      headerProps={{
        back: { to: back ?? '/home' },
        title: <Screen.GagglTitle />,
      }}
    >
      <Screen.Content maxWidth={425}>
        {seriesIsReady && (
          <>
            <TitleToolbar
              text={
                series?.showsTitleOverride && showTitleOverrides
                  ? series?.showsTitleOverride
                  : `${series.city.name} Shows`
              }
              size={!hideOpenStages ? 'md' : undefined}
              className={hideOpenStages ? 'mb-0' : undefined}
            />
            <ShowsTabContent
              hideOpenStages={hideOpenStages}
              titleOverride={{
                collapseTopMargin: hideOpenStages,
                text:
                  series?.showsCalendarTitleOverride && showTitleOverrides
                    ? series?.showsCalendarTitleOverride
                    : undefined,
              }}
              cityId={series.city._id}
              tagIds={[series._id]}
              filter={f7route?.query?.filter}
              onAddEvent={handleAddEvent}
              addShowText={f7route?.query?.addShowText}
              back={back}
              isSuggestionModeDefault={isSuggestionModeDefault}
              hideEntertainerMenuButton={hideEntertainerMenuButton}
            />
          </>
        )}
      </Screen.Content>
    </Screen>
  );
});
